interface SEOHeadProps {
  title: string;
  description: string;
  keywords: string;
  canonicalPath: string;
  ogType?: string;
  ogImage?: string;
  schema?: object;
}

export default function SEOHead({ title, description, keywords, canonicalPath, ogType = 'website', ogImage, schema }: SEOHeadProps) {
  const fullTitle = `${title} | 韩漫 - 韩国漫画大全`;
  const canonical = `https://hanman.com${canonicalPath}`;

  const jsonLdArray: object[] = [];

  if (schema) {
    jsonLdArray.push(schema);
  }

  return (
    <>
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      <link rel="canonical" href={canonical} />

      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:type" content={ogType} />
      <meta property="og:url" content={canonical} />
      <meta property="og:site_name" content="韩漫 - 韩国漫画大全" />
      <meta property="og:locale" content="zh_CN" />
      {ogImage && <meta property="og:image" content={ogImage} />}

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      {ogImage && <meta name="twitter:image" content={ogImage} />}

      <meta name="geo.region" content="CN" />
      <meta name="geo.placename" content="中国" />

      {jsonLdArray.map((ld, i) => (
        <script key={i} type="application/ld+json">{JSON.stringify(ld)}</script>
      ))}
    </>
  );
}